export default function Footer() {
  const year : number = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="grid">
          <div>
            <div className="brand">The TresorSafe</div>
            <p className="small" style={{ marginTop: 10 }}>
              © {year} The TresorSafe — thetresorsafe.com
            </p>
          </div>
          <div>
            <strong>Légal</strong>
            <ul className="small" style={{ listStyle: "none", padding: 0 }}>
              <li>
                <a href="/mentions-legales">Mentions légales</a>
              </li>
              <li>
                <a href="/politique-confidentialite">Politique de confidentialité</a>
              </li>
              <li>
                <a href="/conditions-generales">Conditions générales</a>
              </li>
            </ul>
          </div>
          <div>
            <strong>Contact</strong>
            <p className="small">
              Email :{" "}
              <a href="mailto:contact@thetresorsafe.com">
                contact@thetresorsafe.com
              </a>
              <br />
              Tél. : <a href="tel:+41215190898">+41 21 519 08 98</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
